import apiClient from '@/api';
import { EditProcessObjectRequest } from './types';
import { PROCESS_OBJECTS_ROOT_API_URL } from '../list/constants';
import { ProcessObject } from '../list/types';
import { EditProcessObjectFormSchema } from './edit-process-object-schema';

export function editProcessObject(id: number, payload: EditProcessObjectRequest) {
	return apiClient.patch<ProcessObject>(`${PROCESS_OBJECTS_ROOT_API_URL}/${id}`, payload);
}

export function getEditProcessObjectPayload(
	processObject: ProcessObject,
	values: EditProcessObjectFormSchema
): EditProcessObjectRequest {
	const payload: EditProcessObjectRequest = {};

	if (values.cx !== processObject.cx) {
		payload.cx = values.cx;
	}

	if (values.cy !== processObject.cy) {
		payload.cy = values.cy;
	}

	if (values.trmsLimit !== processObject.trmsLimit) {
		payload.trmsLimit = values.trmsLimit;
	}

	if (values.timeAdjustment !== processObject.timeAdjustment) {
		payload.timeAdjustment = values.timeAdjustment;
	}

	if (values.voltage[0].value !== processObject.kvClass.toString()) {
		payload.voltage = parseInt(values.voltage[0].value);
	}

	if (values.primaryTtms[0].value !== processObject.ttmsIdPrimary.toString()) {
		payload.primaryTtms = parseInt(values.primaryTtms[0].value);
	}

	if (values.secondaryTtms[0].value !== processObject.ttmsIdSecondary.toString()) {
		payload.secondaryTtms = parseInt(values.secondaryTtms[0].value);
	}

	if (values.algorithm[0].value !== processObject.algorithm.toString()) {
		payload.algorithm = parseInt(values.algorithm[0].value);
	}

	return payload;
}
